export const Locales = ["en-GB", "da-DK", "fi-FI", "nb-NO", "sv-SE"] as const;
export type Locale = (typeof Locales)[number];